export enum UserRole {
  ATTORNEY = 'ATTORNEY',
  EXPERT = 'EXPERT',
}

export interface User {
  id: number;
  email: string;
  name: string | null;
  role: UserRole;
  stripeConnectOnboarded?: boolean;
}
